import axios from 'axios'
import store from './store'
import router from './routers'
import message from './message'

function initToken () {
  let token = store.getUser().token
  if (token !== null && token !== "") {
    return {
      token: token,
      platform: 'web'
    }
  } else {
    return { platform: 'web' }
  }
}
let baseUrl = '/api'
//let baseUrl = '/api1'
export default {
  post (url, params) {
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + url, params, {
        headers: initToken()
      })
        .then(res => {
          if (res.data.code === 200) {
            resolve(res.data.msg)
          } else if (res.data.code == 405) {
            //路由到登录页面
            router.push('/login')
            message.error(res.data.msg)
          } else {
            reject(res.data.msg)
          }
        })
        .catch(err => {
          reject(JSON.stringify(err))
        })
    })
  },
  get (url, params) {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + url, {
        params: params,
        headers: initToken()
      }).then(res => {
        if (res.data.code === 200) {
          resolve(res.data.msg)
        } else if (res.data.code == 405) {
          //路由到登录页面
          router.push('/login')
          message.error(res.data.msg)
        } else {
          reject(res.data.msg)
        }
      }).catch(err => {
        reject(JSON.stringify(err))
      })
    })
  },
  downFile (url, params) {
    return new Promise((resolve, reject) => {
      //let baseUrl = "/api"
      //let baseUrl = "/api1"
      axios.get(baseUrl + url, {
        params: params,
        headers: initToken(),
        responseType: 'blob'   //首先设置responseType字段格式为 blob
      }).then(res => {
        const link = document.createElement('a')
        console.log('res', res)
        if (res.status === 200) {
          // 切割出文件名
          const fileNameEncode = res.headers['content-disposition'].split('fileName=')[1]
          // 解码
          console.log('fileNameEncode', fileNameEncode)
          const fileName = decodeURIComponent(fileNameEncode)
          console.log('fileName', fileName)
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          resolve('操作成功！')
        } else if (res.status == 405) {
          //路由到登录页面
          router.push('/login')
          message.error(res.msg)
        } else {
          reject('导出操作失败！')
        }
      }).catch(err => {
        reject(JSON.stringify(err))
      })
    })
  },
}